import { __extends } from "tslib";
import { UpdateApnsChannelRequest, UpdateApnsChannelResponse } from "../models/index";
import { deserializeAws_restJson1UpdateApnsChannelCommand, serializeAws_restJson1UpdateApnsChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateApnsChannelCommand = /** @class */ (function (_super) {
    __extends(UpdateApnsChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateApnsChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateApnsChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: UpdateApnsChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateApnsChannelResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateApnsChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateApnsChannelCommand(input, context);
    };
    UpdateApnsChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateApnsChannelCommand(output, context);
    };
    return UpdateApnsChannelCommand;
}($Command));
export { UpdateApnsChannelCommand };
//# sourceMappingURL=UpdateApnsChannelCommand.js.map